import { openBlock as e, createElementBlock as c, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  d: "M5.75 4.75h.607a.75.75 0 0 0 0-1.5H5.39c-.658 0-1.141.541-1.141 1.154v3.584c0 2.422 1.582 4.562 3.79 4.968v3.498c0 2.536 2.37 4.384 5.032 4.384 2.657 0 5.033-1.854 5.033-4.384v-2.706c1.226-.323 2.145-1.42 2.145-2.749 0-1.587-1.313-2.845-2.895-2.845S14.461 9.412 14.461 11c0 1.328.918 2.425 2.144 2.749v2.706c0 1.48-1.464 2.884-3.533 2.884-2.075 0-3.533-1.398-3.533-2.884V12.96c2.219-.396 3.811-2.542 3.811-4.972V4.404c0-.62-.495-1.154-1.14-1.154h-.915a.75.75 0 0 0 0 1.5h.555v3.238c0 2.039-1.448 3.537-3.05 3.537-1.602 0-3.05-1.498-3.05-3.537V4.75ZM15.96 11c0-.727.609-1.346 1.395-1.346.787 0 1.395.619 1.395 1.345 0 .727-.608 1.346-1.395 1.346-.786 0-1.394-.619-1.394-1.346Z",
  "clip-rule": "evenodd"
}, null, -1), r = [
  n
];
function l(s, d) {
  return e(), c("svg", o, [...r]);
}
const v = { render: l };
export {
  v as default,
  l as render
};
